import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

const swiper = new Swiper(".swiper-latest-medals", {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 0,
    grabCursor: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
    },
});